import React, { Fragment, useEffect } from 'react';
import { useTranslation } from "react-i18next";

// import openSocket from 'socket.io-client';
// import { io } from "socket.io-client";
import { io } from 'socket.io-client';

import { useStore } from '../../hook-store/store';

import { 
  TEXTAUDIOTOOLSNODE_URL, 
  ollamaNodeJsUrl,
} from '../../App';
// import classes from './PostSelect.module.css';

let socket;

function PdfToTextSocket(props) {
  const { uploadApp } = props;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  // const { isAuth } = store.uiStore;
  // const { 
  //   isPdfToTextServerBusy,
  // } = store.pdfToTextStore;
  

  
  
  //// handle speech to text processing
  useEffect(() => {
      // dispatch('SET_ISVOICEGENERATING', false);

      socket = io.connect(ollamaNodeJsUrl, {
        // reconnection: true,
        extraHeaders: {
          // "my-custom-header": "1234",
          "header-client": 'text-audio-tools-frontend',
        }
      });

      // console.log('before socket.on connect')
      socket.on("connect", () => {
        console.log('connect socket.id', socket.id);
        
        //// when connect to nodejs initialize busy state
        dispatch('SET_ISPDFTOTEXTSEVERBUSY', false);

        socket.emit('user-id', {
          socketId: socket.id,
          userId: localStorage.getItem('userId'),
          token: localStorage.getItem('token'),
        });
      });

      socket.on("disconnect", (data) => {
        console.log('disconnect data', data);

        // dispatch('SET_MLSPEECHISSERVER', false);
      });

      socket.on("upload-ollama-nodejs-start", (data) => {
        console.log('upload-ollama-nodejs-start data', data);

        dispatch('SET_ISPDFTOTEXTSEVERBUSY', true);
      });

      // socket.on("upload-nodejs-finish", (data) => {
      //   console.log('upload-nodejs-finish data', data);

      //   dispatch('SET_MLSPEECHISSERVERBUSY', true);
      // });

      socket.on("ptt-processing", (data) => {
        console.log('ptt-processing data', data);

        dispatch('SET_ISPDFTOTEXTSEVERBUSY', true);
      });

      socket.on("ptt-processing-finish", (data) => {
        console.log('ptt-processing-finish data', data);

        dispatch('SET_ISPDFTOTEXTSEVERBUSY', false);
      });

      socket.on("ptt-processing-error", (data) => {
        console.log('ptt-processing-error data', data);

        dispatch('SET_ISPDFTOTEXTSEVERBUSY', false);
      });

      socket.on("large-file-upload-progress", (data) => {
        console.log('large-file-upload-progress data', data);
        
        if (window.location.origin === data.origin && uploadApp === data.uploadApp) {
          const progressPct = data.processed / data.totalChunks * 100
          // dispatch('SET_MLSPEECHISSERVERBUSY', true);
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber40', 'uploading...')} ${progressPct.toFixed(0)}%`,
            message: '',
          });
        }
      });
      
      socket.on("large-file-upload-finish", (data) => {
        console.log('large-file-upload-finish data', data);

        if (window.location.origin === data.origin && uploadApp === data.uploadApp) {
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber41', 'upload finished')}, ${t('audioTranscriber42', 'file processing...')}`,
            message: '',
          });
        }
      });

      return () => {
        socket.off('connect')
        socket.off('disconnect')

        socket.off('upload-ollama-nodejs-start')
        socket.off('upload-ollama-nodejs-finish')
        

        socket.off('ptt-processing-finish')
        socket.off('ptt-processing-error')

        socket.off('large-file-upload-progress');
        socket.off('large-file-upload-finish');
      }
  },[]);


  // //// handle speech to text start
  // useEffect(() => {

  //     socket.on("stt-start-response", (data) => {
  //       console.log('stt-start-response data', data);
  //       dispatch('SET_MLSPEECHISSERVERBUSY', true);
  //     });
    

  //     if (mlSpeechIsUserGenerating) {
  //       socket.emit('stt-start', {
  //         socketId: socket.id,
  //         userId: localStorage.getItem('userId'),
  //         time: Date.now(),
  //         // token: localStorage.getItem('token'),
  //       });

  //       dispatch('SET_MLSPEECHISSERVERBUSY', true);

  //     } else {
  //       dispatch('SET_MLSPEECHISSERVERBUSY', false);
  //     }

  //     return () => {
  //       socket.off('stt-start-response');
  //     }
  // },[mlSpeechIsUserGenerating]);

  return (
    <Fragment></Fragment>
  );
}

export default PdfToTextSocket;